<div class="override-component" *ngxPermissionsOnly="['Bin:View']">
  <div class="company-container">
    <div class="top-part">
      <div class="top-part-wrap">
        <div class="first-section d-flex align-items-center">
          <h5 class="mb-0 table-title">Production Bins</h5>
        </div>

        <div
          class="second-section d-flex align-items-center justify-content-end g-3"
          style="display: flex; gap: 25px; padding-bottom: 1em"
        >
          <!-- Search Bar -->
          <div class="searchbar d-flex ms-2">
            <img
              class="search me-2"
              src="../../../assets/icons/searchbar.svg"
              alt="Search"
            />
            <input
              type="text"
              placeholder="Search by Reference No"
              (input)="onSearchInput($event)"
            />
          </div>

          <!-- Create Button -->
          <div class="create-btn p-3">
            <button
              class="btn add-btn"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
              (click)="resetListingForm()"
              *ngxPermissionsOnly="['Bin:Create']"
            >
              + Create Bin
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Data Table -->
    <section class="intro">
      <div class="table-container">
        <table class="table category-table table-condensed">
          <colgroup>
            <col style="width: 22%" />
            <col style="width: 38%" />
            <col style="width: 14%" />
            <col style="width: 14%" />
            <col style="width: 12%" />
          </colgroup>
          <thead class="main-head sticky-top">
            <tr>
              <th scope="col">Reference Number</th>
              <th scope="col">Description</th>
              <th scope="col" class="text-center">Status</th>
              <th scope="col">Created Date</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let containerItem of containerList">
              <td>{{ containerItem.referenceNumber }}</td>
              <td>{{ containerItem.description }}</td>
              <td class="text-center">
                <span
                  [ngClass]="getStatusClass(containerItem.status)"
                  class="status-badge"
                >
                  {{ getStatusLabel(containerItem.status) }}</span
                >
              </td>
              <td>{{ containerItem.createdAt | date: "MM-dd-yyyy" }}</td>

              <td>
                <div class="d-flex align-items-center">
                  <span matTooltip="Edit Record" matTooltipPosition="above" *ngxPermissionsOnly="['Bin:Update']">
                    <img
                      src="../../../assets/Pricingscreen/update.svg"
                      class="svg-icon ms-3"
                      style="cursor: pointer"
                      alt="Edit"
                      (click)="onEditContainer(containerItem.id)"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasRight"
                      aria-controls="offcanvasRight"
                    />
                    
                  </span>

                  <span
                    matTooltip="Print Bin Label"
                    matTooltipPosition="above"
                    class="relative"
                  >
                    <ng-container>
                      <img
                        src="../../../assets/onboarding/ic_printer.svg"
                        class="svg-icon ms-3"
                        alt="Print"
                        (click)="onPrintContainer(containerItem)"
                        style="cursor: pointer ; opacity: 0.8;"
                      />
                    </ng-container>
                  </span>

                  <span
                    matTooltip="Delete Record"
                    matTooltipPosition="above"
                    *ngxPermissionsOnly="['Bin:Delete']"
                  >
                    <img
                      src="../../../assets/Pricingscreen/delete.svg"
                      class="svg-icon ms-3"
                      style="cursor: pointer"
                      alt="Delete"
                      (click)="onDeleteContainer(containerItem)"
                      data-bs-toggle="modal"
                      data-bs-target="#deleteDataModal"
                    />
                  </span>
                </div>
              </td>
            </tr>

            <!-- Empty State -->
            <tr *ngIf="containerList.length === 0">
              <td colspan="5" rowspan="15" class="text-center py-4 w-100">
                <p class="mb-0 text-muted fs-5">No production bins found</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</div>

<!-- Add/Update Container Form -->
<app-add-update-container
  [container]="container"
  [CompanyId]="CompanyId"
  [StoreId]="StoreId"
  (saved)="onContainerSaved()"
  (resetFormEvent)="onResetForm()"
></app-add-update-container>

<!-- Delete Confirmation Modal -->
<div
  class="modal fade"
  id="deleteDataModal"
  aria-hidden="true"
  aria-labelledby="deleteDataModalLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteDataModalLabel">Delete</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="cancelDelete()"
        ></button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete this bin <strong *ngIf="containerToDelete">({{ containerToDelete.referenceNumber }})</strong>?</p>
      </div>
      <div class="modal-footer">
        <button class="btn modal-btn me-2" data-bs-dismiss="modal" (click)="cancelDelete()">
          Cancel
        </button>
        <button
          class="btn modal-btn"
          data-bs-dismiss="modal"
          (click)="confirmDelete()"
          style="background-color: rgb(23, 95, 145); color: white"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal for Select Label Format -->
<div
  class="modal fade"
  id="labelFormatModal"
  tabindex="-1"
  aria-labelledby="labelFormatModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title" id="labelFormatModalLabel">
          Select Print Format
        </h5>
        <button
          type="button"
          class="btn-close"
          (click)="closeModalDialog()"
        ></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label"
            >Print Format <span class="required-star">*</span></label
          >

          <select class="form-select" [(ngModel)]="selectedLabelFormat">
            <option [ngValue]="null" disabled>Select print format</option>
            <option *ngFor="let format of labels" [ngValue]="format">
              {{ format.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeModalDialog()"
        >
          Cancel
        </button>

        <button
          type="button"
          class="btn btn-primary"
          style="padding-inline: 25px"
          [disabled]="!selectedLabelFormat || isPrinting"
          (click)="confirmPrint()"
        >
          <span *ngIf="!isPrinting">Print</span>
          <span *ngIf="isPrinting">
            Printing
            <i class="fa fa-spinner fa-spin ms-2 print-spinner-icon"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>